import React from "react";
import {
    Modal,
    Box,
    Typography,
    IconButton,
    Divider,
    Stack,
    Grid,
    Avatar,
    Button,
    Chip,
    Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { getInitials, stringToColor } from "../utils/DataHelper";
import dayjs from "dayjs";

export default function RecordDetailModal({ open, onClose, data, title = "Record Detail" }) {


    const avatarColor = stringToColor(data?.name_full);

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "92vw", md: "70vw", lg: "58vw" },
                    maxHeight: "86vh",
                    bgcolor: "background.paper",
                    borderRadius: 4,
                    boxShadow: "0 24px 60px rgba(15,23,42,0.25)",
                    border: "1px solid",
                    borderColor: "divider",
                    p: { xs: 2, md: 3 },
                    overflow: "hidden",
                }}
            >
                {/* Header */}
                <Stack direction="row" spacing={1.5} alignItems="center">
                    {/* Avatar */}
                    {data ? (
                        <>
                            <Avatar
                                sx={{
                                    bgcolor: avatarColor,
                                    color: "#fff",
                                    fontWeight: 700,
                                    width: 42,
                                    height: 42,
                                    fontSize: 15,
                                }}
                            >
                                {getInitials(data.name_full)}
                            </Avatar>

                            <Box flex={1}>
                                <Typography variant="h5" fontWeight={800}>
                                    {data.name_full}
                                </Typography>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography variant="body2" color="text.secondary">
                                        {data.idjemaat}
                                    </Typography>
                                    {data.isbetaniamember !== undefined && (
                                        <Chip
                                            size="small"
                                            label={data.isbetaniamember === 1 ? "Member" : "Non Member"}
                                            color={data.isbetaniamember === 1 ? "success" : "default"}
                                        />
                                    )}
                                </Stack>
                                {/* <Typography>{JSON.stringify(data)}</Typography> */}
                            </Box>



                        </>
                    ) : null}

                    <IconButton
                        onClick={onClose}
                        sx={{ position: "absolute", top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Stack>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ overflowY: "auto", maxHeight: "60vh", pr: 1, p: 2 }}>
                    {data ? (
                        <Box >
                            <Grid container spacing={1}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <HVText accentColor={avatarColor} label="Nomor Anggota" value={data.idjemaat} />
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <HVText accentColor={avatarColor} label="Nama Panggilan" value={data.name_nick} />
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <HVText accentColor={avatarColor} label="Telepon" value={data.phone_mobile} />
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <HVText accentColor={avatarColor} label="Status Jemaat" value={data.status_jemaat} />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <HVText accentColor={avatarColor} label="Alamat" value={data.alamat} />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <HVText accentColor={avatarColor} label="Kelahiran" value={data.lahir_tempat + ", " + dayjs(data.lahir_date).format("DD MMMM YYYY")} />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <HVText accentColor={avatarColor} label="Gender" value={data.gender === "L" ? "Laki-laki" : "Perempuan"} />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <HVText accentColor={avatarColor} label="Terdaftar Betania" value={
                                        dayjs(data.betaniamemberestablished).format("DD MMMM YYYY")} />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <HVText
                                        accentColor={avatarColor}
                                        label="Terakhir Diperbarui"
                                        value={data.dtupdate ? dayjs(data.dtupdate).format("DD MMMM YYYY") : "-"}
                                    />
                                </Grid>
                            </Grid>

                            <Divider sx={{ my: 2 }} />

                            <PaperSummary data={data} />
                        </Box>


                    ) : (
                        <Typography color="text.secondary" align="center">
                            No data available
                        </Typography>
                    )}
                </Box>


                <Divider sx={{ my: 2 }} />
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }} >
                    <Button
                        variant="outlined"
                        startIcon={<WhatsAppIcon />}
                        onClick={() => {
                            const phone = (data?.phone_mobile || "").replace(/[^0-9]/g, "");
                            if (!phone) return;
                            const url = `https://wa.me/${phone}`;
                            window.open(url, "_blank");
                        }}
                    >
                        WhatsApp
                    </Button>
                    <Button variant="contained" onClick={onClose}  >
                        Pembayaran
                    </Button>
                    <Button variant="outlined" onClick={onClose}  >
                        Tutup
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

const HVText = ({
    label,
    value,
    accentColor = "#9e5bad",
    minHeight = 72,
    copyable = false,
}) => {
    const displayValue =
        value === null || value === undefined || value === ""
            ? "-"
            : value;

    return (
        <Box
            sx={{
                overflow: "hidden",
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                transition: "all .2s ease",
                "&:hover": {
                    bgcolor: "action.hover",
                    transform: "translateY(-1px)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                },
            }}
        >
            <Stack direction="row" alignItems="stretch">
                {/* Accent bar */}
                <Box
                    sx={{
                        width: 6,
                        bgcolor: accentColor,
                        minHeight,
                    }}
                />

                {/* Content */}
                <Box flex={1} sx={{ px: 2, py: 1.2, display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ fontWeight: 600 }}
                        >
                            {label}
                        </Typography>

                        <Typography
                            variant="body1"
                            color="text.primary"
                            sx={{ fontWeight: 500 }}
                        >
                            {displayValue}
                        </Typography>
                    </Box>
                    {copyable && displayValue !== "-" && (
                        <Tooltip title="Copy">
                            <IconButton
                                size="small"
                                onClick={() => {
                                    navigator.clipboard?.writeText(String(displayValue));
                                }}
                            >
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </Stack>
        </Box>
    );
};

const PaperSummary = ({ data }) => {
    return (
        <Box
            sx={{
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                p: 2,
                background: "rgba(148,163,184,0.08)",
            }}
        >
            <Typography variant="subtitle2" fontWeight={700} mb={1}>
                Ringkasan Pembayaran
            </Typography>
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <SummaryItem label="Status" value={data?.status_jemaat || "-"} />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <SummaryItem
                        label="Member Sejak"
                        value={data?.betaniamemberestablished ? dayjs(data.betaniamemberestablished).format("DD MMM YYYY") : "-"}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <SummaryItem label="Nomor Anggota" value={data?.idjemaat || "-"} />
                </Grid>
            </Grid>
        </Box>
    );
};

const SummaryItem = ({ label, value }) => (
    <Box>
        <Typography variant="caption" color="text.secondary">
            {label}
        </Typography>
        <Typography variant="body2" fontWeight={600}>
            {value}
        </Typography>
    </Box>
);
